import axios from "../../../util/axios";

export default {
    queryList: (data) => axios.get({url: "/basedata/sync/dataSync/queryList", data: data}),

    runJob: (jobId, params) => axios.get({url: "/basedata/sync/dataSync/run", data: {jobId, params}}),

    stopJob: (jobId) => axios.get({url: "/basedata/sync/dataSync/stop", data: {jobId}}),

    startJob: (jobId) => axios.get({url: "/basedata/sync/dataSync/start", data: {jobId}}),

    updateJob: (data) => axios.post({url: "/basedata/sync/dataSync/update", data: data}),

    queryAllExecutor: () => axios.get({url: "/basedata/sync/dataSync/queryAllExecutor"}),
}